import { render, staticRenderFns } from "./todoGroup.vue?vue&type=template&id=396a1c19&"
import script from "./todoGroup.vue?vue&type=script&lang=js&"
export * from "./todoGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports